import angular = require('angular');
import _ = require('underscore');
import { EnumService } from '../../../app.common/modules/common/services/enum.service';

class CampaignType {
    type: number;
    exclusive: boolean;
    private campaignsType = ['', 'offer', 'promotion', 'advertisement', 'flash sale', 'event', 'voucher', 'referral offer', 'advent promotion', 'hero offer'];
    private jispExclusive = 'Jisp exclusive ';

    constructor(private enumService: EnumService) { }

    getMessage() {
        var type = this.campaignsType[this.type];
        var addExclusive = (this.exclusive && (this.type < this.enumService.CampaignType.ExclusiveOffer));
        return (addExclusive ? this.jispExclusive : '') + (addExclusive ? type : this.capitalise(type));
    }

    private capitalise(msg: string) {
        return (msg && _.size(msg) > 1) ? (msg.charAt(0).toUpperCase() + msg.slice(1).toLowerCase()) : '';

    }
}

angular
    .module('app.retailes.common')
    .component('campaignType', {
        template: require('./campaignType.html'),
        controller: CampaignType,
        controllerAs: 'vm',
        bindings: {
            type: '<',
            exclusive: '<',
        }
    });



// WEBPACK FOOTER //
// ./src/app.retailer.common/components/campaign-type/campaignType.component.ts